import React, { useEffect } from 'react';
import {
  Box,
  GDSStyleObject,
  ParagraphText,
  StackLayout,
} from '@leagueplatform/genesis-core';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import * as CONSTANTS from '../utils/constant';
import { HeaderComponent } from './header.component';
import { ListingComponent } from './listing.component';
import { NoDocsComponent } from './no-docs.component';
import { scrollToTop, getDocumentsList } from '../helper/helpers';
import { documentsList } from '../utils/utils';

export function DetailPageComponent(props: any) {
  const {
    id,
    ubkValue,
    isLoading,
    setIsLoading,
    allDocs,
    allEobDocsEmpty,
    allumLettersEmpty,
    fetchDocumentsList,
    setErrMsg,
    accessToken,
    medicareMember,
    fireBaseFlagsConfig,
  } = props;

  const currentState = documentsList[id] || null;
  const currrentDocsList: any = allDocs[id]?.length ? allDocs[id] : [];

  const getScreenNameForAnalytics = () => {
    if (id === CONSTANTS.DETERMINATION_NOTICES) {
      return CONSTANTS.DETERMINATION_NOTICES_TITLE;
    }
    if (id === CONSTANTS.EOB) {
      return CONSTANTS.EXPLANATION_OF_BENEFITS;
    }
    if (id === CONSTANTS.WELCOME_GUIDES) {
      return CONSTANTS.WELCOME_GUIDES_TITLE;
    }
    return null;
  };

  useEffect(() => {
    scrollToTop();
    if (!currrentDocsList.length && accessToken) {
      if (id === CONSTANTS.EOB && !allEobDocsEmpty) {
        fetchDocumentsList(CONSTANTS.EOB);
        return;
      }
      const documentTypes = getDocumentsList(
        ubkValue,
        medicareMember,
        fireBaseFlagsConfig,
      );

      const isMemberEligible = Object.keys(documentTypes).includes(id) || false;
      if (
        id === CONSTANTS.DETERMINATION_NOTICES &&
        !allumLettersEmpty &&
        isMemberEligible
      ) {
        fetchDocumentsList(CONSTANTS.DETERMINATION_NOTICES);
      }
      if (id === CONSTANTS.WELCOME_GUIDES && isMemberEligible) {
        fetchDocumentsList(CONSTANTS.WELCOME_GUIDES);
      }
    }
    trackAnalyticsEvent(EVENT_NAME.SCREEN_LOADED, {
      screen_name: getScreenNameForAnalytics(),
      product_area: CONSTANTS.DOCUMENT_CENTER,
      path: window.location.pathname,
      event_author: CONSTANTS.ENGEN,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  return (
    <Box
      css={
        {
          display: 'flex',
          flexDirection: 'column',
        } as GDSStyleObject
      }
    >
      <HeaderComponent isAllDocs title={currentState?.name} />
      {!currrentDocsList.length && !isLoading ? (
        <Box
          css={{
            textAlign: 'center',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            height: '70vh',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 24px',
            '@mobile': {
              height: '75vh',
            },
          }}
        >
          <NoDocsComponent
            isAllDocs
            letterType={
              id === CONSTANTS.DETERMINATION_NOTICES
                ? CONSTANTS.DETERMINATION_NOTICES_TITLE
                : CONSTANTS.EXPLANATION_OF_BENEFITS
            }
          />
        </Box>
      ) : (
        <StackLayout
          orientation="horizontal"
          spacing={{ '@desktop': '$two' }}
          css={{
            display: 'block',
            width: '100%',
            maxWidth: '898px',
            margin: '$none auto',
            '@desktop': { paddingBottom: '50px' },
            '@laptop': { paddingBottom: '50px' },
            '@mobile': { padding: '24px 24px 50px' },
            '@tablet': { padding: '24px 24px 50px' },
            '@mobileLandscape': { padding: '24px 24px 50px' },
          }}
        >
          <ParagraphText
            css={{
              flex: '0 0 100%',
              margin: '0',
              marginBlockEnd: '24px !important',
              fontFamily: `${CONSTANTS.FONT_ROBOTO}`,
              color: '#2C3135',
              marginBottom: 0,
              '@desktop': {
                marginTop: '24px',
                padding: '24px 0 12px',
                marginBlockEnd: '0 !important',
              },
              '@laptop': {
                marginTop: '24px',
                padding: '24px 0 12px',
                marginBlockEnd: '0 !important',
              },
            }}
          >
            {currentState?.description}
          </ParagraphText>
          <Box
            css={{
              marginTop: 0,
              paddingBottom: '24px',
            }}
          >
            <ListingComponent
              docsList={currrentDocsList}
              isAllDocs
              setIsLoading={setIsLoading}
              setErrMsg={setErrMsg}
              accessToken={accessToken}
            />
          </Box>
        </StackLayout>
      )}
    </Box>
  );
}
